const canUseDOM = () => !!(typeof window === 'object' && window && window.document && window.document.createElement);

module.exports = canUseDOM;
